import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { AdvertiserApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';

import { 
  InputField,
  required,
  url 
} from '../../form';

class SettingsForm extends Component {
  onFormSubmit(values) {
    const { 
      dispatch,
      account,
    } = this.props;
    
    const args = [account.uuid, values];

    dispatch(setLoader('AccountForm'));

    dispatch(AdvertiserApi.actions.accountUpdate.post(...args, (_error, success) => {
      dispatch(removeLoader('AccountForm'));
      if (success) {
        dispatch(AdvertiserApi.actions.accounts());
      }
    }));
  }

  render() {
    const { handleSubmit, formAction, isLoading } = this.props;
    
    return (
      <div className="ibox">
        <div className='ibox-title border-bottom'>
          <h5>Account Info</h5>      
        </div>
        <div className="p-b-lg ibox-content">
          <form 
            onSubmit={handleSubmit(this.onFormSubmit.bind(this))} 
            className='m-t'
          >
            <Field 
              type='text' 
              name='name' 
              placeholder='Name of your company'
              label='Name' 
              component={InputField}
              validate={[required]}
            />
            <Field 
              type='text' 
              name='website' 
              placeholder='Company website'
              label='Website' 
              component={InputField}
              validate={[required, url]}
            />

            <Button 
              type='submit' 
              loading={isLoading} 
              bsStyle='primary'
            >
              {formAction || 'Submit'}
            </Button>
          </form>
        </div>
      </div>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'AccountForm'
});

const mapStateToProps = (state, ownProps) => {
  const { loader } = state;
  const account = ownProps.account;
  const isLoading = loader.includes('AccountForm');

  const initialValues = {
    name: account.name, 
    website: account.website,
    status: account.status
  };
  
  return { isLoading, initialValues, account };
};

export default connect(mapStateToProps, null, null, { withRef: true })(ResourceForm(SettingsForm));
